import { render, staticRenderFns } from "./ViewSettingsOrganisation.vue?vue&type=template&id=7a4fdbdf&scoped=true&"
import script from "./ViewSettingsOrganisation.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsOrganisation.vue?vue&type=style&index=0&id=7a4fdbdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4fdbdf",
  null
  
)

export default component.exports